/**
 * 统一生成带 token/username 的请求头，避免各业务 API 重复读取本地登录信息。
 * @param {Record<string, any>} extraHeaders 需要额外合并到请求头中的字段。
 * @param {Object} [options]
 * @param {boolean} [options.includeUsername=true] 是否在请求头中附带 username。
 * @returns {Record<string, any>}
 */
export const getAuthHeaders = (extraHeaders = {}, options = {}) => {
  const { includeUsername = true } = options
  const token = localStorage.getItem('token') || ''
  const headers = {
    token,
    Authorization: token,
  }

  if (includeUsername) {
    headers.username = localStorage.getItem('username') || sessionStorage.getItem('username') || ''
  }

  return {
    ...headers,
    ...extraHeaders,
  }
}
